import { filter, mapTo } from "rxjs/operators";
import { TypeActionLoading } from "../../../loading/actionLoading";
import { IdAssetBundleCore } from "../../../loading/IdAssetBundleCore";
import { actionGameTrackingUpdateClientFunnel } from "../../actionGameTracking";
import { IdGameTrackingClientFunnelState } from "../IdGameTrackingClientFunnelState";
export var epicGameTrackingClientFunnelPlayerBaseShow = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionLoading.Complete &&
            action.bundleId === IdAssetBundleCore.Initial;
    }), mapTo(actionGameTrackingUpdateClientFunnel(IdGameTrackingClientFunnelState.PLAYER_BASE_SHOW)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/game-funnel/epics/epicGameTrackingClientFunnelPlayerBaseShow.ts
// module id = 1871
// module chunks = 3